Controller = App.loadClass 'core::Angular/Controller'

class exports.ConfirmationManagementZoneController extends Controller
    constructor: (@scope, @transitions, @state, @generate, @data, @loader, @window) ->
        super(@scope, @transitions)
        @scope.resize = 0

        # load the data for select boxes
        @loadSelectData()

        # functions
        @scope.alphabeticalComparison = @alphabeticalComparison
        @scope.getShapefileCategories = @getShapefileCategories
        @scope.getShapefileAttributes = @getShapefileAttributes
        @scope.getShapefileColumnValues = @getShapefileColumnValues
        @scope.updateMapPartialRow = @updateMapPartialRow
        @scope.resetShapefileDropdowns = @resetShapefileDropdowns
        @scope.confirm = @confirm
        @scope.close = @close
        @scope.socketUpdateVps = @socketUpdateVps
        @scope.checkStatus = @checkStatus
        @scope.setPlaceholderText = @setPlaceholderText
        @scope.filterGroupBy = @filterGroupBy
        @scope.autoloadDropdown = @autoloadDropdown
        @scope.resizeTable = () => @scope.resize++
        @window.conversionRequestSent = @conversionRequestSent
        @scope.paginate = @paginate

    conversionRequestSent: (data) =>
        @scope.$emit 'uploads:processing'

    alphabeticalComparison = (a, b) ->
        # force reconfirm to show first in the list
        if a.data.status is 'Reconfirm'
            return -1
        if b.data.status is 'Reconfirm'
            return 1

        result = strnatcasecmp(a.data.status, b.data.status)

        if result is 0
            result = strnatcasecmp(a.data.reference.farmName, b.data.reference.farmName)

        if result is 0
            result = strnatcasecmp(a.data.reference.fieldName, b.data.reference.fieldName)

        if result is 0
            result = strnatcasecmp(a.data.selected.year, b.data.selected.year)

        return result

    loadSelectData: () =>
        # Array of all years from 2005 to current crop year
        @data.getAllYears().then (response) =>
            if response?.data?.status?.type is 'success'
                @scope.years = response.data.data

        # Array of crops
        @data.getCrops().then (response) =>
            if response?.data?.status?.type is 'success'
                @scope.crops = response.data.data

        @data.getShapefileCategories().then (response) =>
            if response?.data?.status?.type is 'success'
                @scope.categories = response.data.data

    paginate: (table_state, @cnt) =>
        if @reload
            @reload = false
            table_state.pagination.start = 0
            table_state.pagination.number = 25

        @loadRowData table_state.pagination.start or 0, table_state.pagination.number or 25
            .then (result) =>
                table_state.pagination.totalItemCount = result
                table_state.pagination.numberOfPages = Math.ceil(result / table_state.pagination.number)
            .catch (err) =>
                @setAlert
                    msg: 'Error loading data'
                    type: 'error'
            .finally () =>
                @scope.resize++
                @loader.hideAll()
                return true


    loadRowData: (skip = 0, take = 10) =>
        # show loader while we get data
        @loader.overMap 'Loading...'

        # Fetch the content
        @data.getManagementZoneRows(skip, take).then (response) =>
            if response?.data?.status?.type is 'success'
                @scope.rows = response.data.data.rows
                @data.setRows(@scope.rows)
                for row in @scope.rows
                    if row.preloaded?
                        row.selected = row.preloaded
                    else
                        row.selected = {}

                    row.disabled = {
                        confirm: false
                    }

                    @validate(row)

                return response.data.data.count

    validate: (row) =>
        # default to enabled
        row.disabled.confirm = false
        # validate selections and status
        if not @validateBasicSelections(row.selected) or not @validateGroupBy(row.selected) or not @validateStatus(row)
            row.disabled.confirm = true

    validateStatus: (row) =>
        return row.end.status in ['Confirm', 'Reconfirm']

    validateBasicSelections: (selected) =>
        return selected.year and selected.category?.id and selected.group_by

    validateGroupBy: (selected) =>
        # validate group by and variable selection based on group by selection
        if not selected.category?.name
            return false
        else if selected.category?.name is 'Irrigation'
            # ensure that we have selected a dryland value
            if not selected.dryland_value
                return false
        else if selected.category?.name is 'Productivity'
            # ensure that we have selected a crop
            if not selected.mmz_crop
                return false

        return true

    getShapefileColumnValues: (row) =>
        row.fetching = true
        @data.getShapefileColumnValues(row).then (response) =>
            if response.data?.status?.type is 'success'
                row.required.dryland_values = response.data.data
                @autoloadDropdown(row, 'dryland_values', 'dryland_value')
                row.fetching = false

    updateMapPartialRow: (row) =>
        # Save user selection and check status
        @data.saveMapPartialSelections(row).then (response) =>
            jsr = response.data.data
            if response?.data?.status?.type is 'success'
                row.end.status = if jsr.status? then jsr.status else row.end.status
                row.can_confirm = response.data.data.can_confirm
                @validate(row)

    resetShapefileDropdowns: (row, specific = null) =>
        if specific is 'dryland'
            return row.selected.dryland_value = null

        if not specific
            row.selected.group_by = null
            row.selected.mmz_crop = null
            row.selected.dryland_value = null
            @setPlaceholderText(row)

        @validate(row)

    confirm: (row) =>
        # Array of valid_point_sets or shapefiles we'll be updating
        update_array = []

        # Flag used to control updateRow() branching
        is_shapefile = row.reference.map_partials_id?

        # Build template object(s) used by the backend
        if is_shapefile
            update_array.push {
                id: row.reference.map_partials_id
                fields_id: row.reference.field_id
                year: row.selected.year
                category: row.selected.category
                group_by: row.selected.group_by
                crop: row.selected.mmz_crop
                dryland_value: row.selected.dryland_value
            }

        row.can_confirm = false
        row.end.status = 'Processing'

        # Send the objects to the backend to update the db
        @generate.updateRow(update_array, is_shapefile, @scope.tab).then (response) =>
            status = response.data.data
            # update parent status
            if status is 'Processing'
                row.end.status = status
            if status is 'Processed'
                row.end.status = 'Done'

    updateTab: () =>
        unconfirmed = 0

        for row in @scope.rows
            if row.end.status in ['Confirm', 'Reconfirm']
                unconfirmed += 1

        @scope.tabs.mmz.unconfirmed = unconfirmed

    close: () =>
        @state.go 'data.add.upload'

    socketUpdateVps: (data) =>
        # Find children amongst row  objects and update the status
        children = []
        for vps_id, status of data
            children.push vps_id
            for row in @scope.rows
                for i, child of row.children
                    if child.end.id is Number(vps_id)
                        child.end.status = status

        # update parents
        for row in @scope.rows
            done = true
            # see if all children for a given parent are done
            for i, child of row.children
                failed = child.end.status is 'Failed'
                if child.end.status isnt 'Processed'
                    done = false

            row.end.status = 'Done' if done
            row.end.status = 'Failed' if failed

        _.defer () =>
            @scope.$apply()


    checkStatus: (row) =>
        # Handle disabling/enabling the confirm button
        for i, value of row.selected
            if value is null or value is undefined
                if row.selected.number_of_products is 2
                    row.can_confirm = true
                else
                    row.can_confirm = false
            else
                row.can_confirm = true

        # Check for Reconfirmation and update accordingly
        if row.confirmed_data isnt false
            reconfirm = false
            map =
                crops_id: row.selected.crop?.id
                seed_companies_id: row.selected.seed_company?.id
                hybrids_id: row.selected.product?.id
                year: parseInt(row.selected.year)

            for property, value of row.confirmed_data
                reconfirm = true if map[property] isnt value

            if reconfirm is true
                row.end.status = 'Reconfirm'
            else
                row.can_confirm = false
                row.end.status = 'Done'

    setPlaceholderText: (row) =>
        return 'Select...' if not row.selected.category

        switch row.selected.category.name
            when 'Productivity'
                return 'Select Yield Label...'
            when 'Irrigation'
                return 'Select Irrigation Label...'

    autoloadDropdown: (row, options, property) =>
        row.selected[property] = row.required[options][0] if row.required[options].length is 1
        @updateMapPartialRow row

    filterGroupBy: (row) =>
        row.fetching = true
        @data.getShapefileAttributes(row).then (response) =>
            if response.data?.status?.type is 'success'
                if response.data.data.length is 0
                    row.selected.group_by = 'No valid attributes found'
                    row.invalid = true
                    $("#row#{row.reference.map_partials_id}").addClass('category-error')
                else
                    row.required.group_by = response.data.data
                    @autoloadDropdown(row, 'group_by', 'group_by')
                    row.invalid = false
                    row.fetching = false

                @updateMapPartialRow(row)

    getSeedCompaniesByCrop: (product, crop, reset = true) =>
        if reset
            # reset selections
            product.selected.seedCompany = null
            product.selected.product = null

        # fetch seed companies
        @generate.getSeedCompaniesByCrop(crop.id).then (response) =>
            if response?.data?.status?.type is 'success'
                # set seed companies list
                product.required.seedCompanies = response.data.data
